export default __webpack_public_path__ + "d2a2a80385468e2abc82ecf2742b1182.jpg";